import type { Router } from 'vue-router';

import { readonly, shallowRef } from 'vue';

export interface ChunkLoadingErrorState {
  message: string;
}

const chunkLoadingError = shallowRef<ChunkLoadingErrorState | null>(null);

export const chunkLoadingErrorState = readonly(chunkLoadingError);

export const reloadAfterChunkLoadingError = (): void => {
  window.location.reload();
};

/**
 * Настраивает обработку ошибок загрузки динамических модулей (chunk loading errors)
 * После деплоя хеши файлов меняются, что вызывает ошибки у пользователей с открытой страницей
 */
export function setupChunkLoadingErrorHandler(router: Router): void {
  router.onError((error) => {
    const isChunkLoadError =
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Unable to preload CSS') ||
      error.message.includes('Importing a module script failed');

    if (isChunkLoadError) {
      const hasReloaded = sessionStorage.getItem('chunk-reload');

      if (!hasReloaded) {
        // Перезагружаем страницу один раз
        sessionStorage.setItem('chunk-reload', 'true');
        window.location.reload();
      } else {
        // После повторной ошибки оставляем recovery пользователю и не запускаем reload-loop.
        chunkLoadingError.value = {
          message: 'Не удалось загрузить приложение. Обновите страницу или повторите попытку позже.',
        };
        console.error('[router.chunk] Chunk loading failed after automatic reload');
      }
    }
  });

  // Очищаем флаг перезагрузки при успешной навигации
  router.afterEach((_to, _from, failure) => {
    if (failure) {
      return;
    }

    sessionStorage.removeItem('chunk-reload');
    chunkLoadingError.value = null;
  });
}
